import { LitElement as p, unsafeCSS as c } from "lit";
import { property as l, state as n } from "lit/decorators.js";
import u from "../../shared/reset.style.css.js";
import { booleanType as o } from "../../utils/property-types.js";
import f from "./chip.style.css.js";
import { template as b } from "./chip.template.js";
var y = Object.defineProperty, s = (r, e, t, m) => {
  for (var a = void 0, d = r.length - 1, h; d >= 0; d--)
    (h = r[d]) && (a = h(e, t, a) || a);
  return a && y(e, t, a), a;
};
class i extends p {
  constructor() {
    super(...arguments), this.size = "lg", this.icon = "", this.label = "", this.hasDelete = !1, this.disabled = !1, this.selected = !1, this.disableSelect = !1, this._isSelectFocused = !1, this._isLabelTruncated = !1, this._isFirstUpdated = !0;
  }
  static get styles() {
    return [c(u), c(f)];
  }
  handleToggle() {
    this.disableSelect || this.disabled || (this.selected = !this.selected, this.dispatchEvent(
      new CustomEvent("onToggle", {
        detail: {
          text: this.label,
          selected: this.selected
        }
      })
    ));
  }
  handleKeydown(e) {
    e.stopPropagation(), (e.key === "Enter" || e.key === "Space") && this.handleToggle();
  }
  handleDelete(e) {
    e.stopPropagation(), this.dispatchEvent(
      new CustomEvent("onDelete", {
        detail: {
          text: this.label
        }
      })
    );
  }
  onSelectFocusIn(e) {
    if (this.disabled || this.disableSelect) return;
    const t = e.target;
    this._isSelectFocused = !!(t != null && t.matches(":focus-visible"));
  }
  onSelectFocusOut() {
    this._isSelectFocused = !1;
  }
  async firstUpdated() {
    await this.updateComplete, this._checkLabelTruncated(), this._isFirstUpdated = !1;
  }
  willUpdate(e) {
    !this._isFirstUpdated && e.has("label") && this._checkLabelTruncated();
  }
  _checkLabelTruncated() {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".dss-chip__label");
    e && (this._isLabelTruncated = e.scrollWidth > e.offsetWidth, this.requestUpdate());
  }
  render() {
    return b(this);
  }
}
s([
  l({ type: String })
], i.prototype, "size");
s([
  l({ type: String })
], i.prototype, "icon");
s([
  l({ type: String })
], i.prototype, "label");
s([
  l(o)
], i.prototype, "hasDelete");
s([
  l(o)
], i.prototype, "disabled");
s([
  l(o)
], i.prototype, "selected");
s([
  l(o)
], i.prototype, "disableSelect");
s([
  n()
], i.prototype, "_isSelectFocused");
export {
  i as Chip
};
//# sourceMappingURL=chip.js.map
